import { BrowserRouter, Routes, Route } from 'react-router-dom';
/* test routes */
import PrivateRoute from '../../Components/Admin/Functions/PrivateRoute.js';
import { RoutesEntitiesTest } from '../../Pages/Testing/RoutesEntitiesTest.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const TestRoutesEntities = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<PrivateRoute />}>
                    <Route path={`/admin/test/routes/entities`} element={<RoutesEntitiesTest />} />
                </Route>
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    )
}